import MetricBase from "models/metrics/MetricBase";
import EmptyUnit from "models/metrics/unit/EmptyUnit";
import i18n from "i18next";
import ConnectivityGroup from "../../../../groups/ConnectivityGroup";

class MetricNoTaxBreakdownCount extends MetricBase {
    constructor() {
        super({
            field: "metric_noTaxBreakdownCount",
            defaultVisibility: true,
            unit: new EmptyUnit(),
            chartName: i18n.t("metrics.google_hotel_ads.noTaxBreakdownCount.chartName"),
            serieLabel: i18n.t("metrics.google_hotel_ads.noTaxBreakdownCount.serieLabel"),
            tooltip: i18n.t("metrics.google_hotel_ads.noTaxBreakdownCount.tooltip"),
            group: new ConnectivityGroup(),
        });
    }
}

export default MetricNoTaxBreakdownCount;
